/**
 * @description Error colors are used across error states and in "destructive" actions. They communicate a destructive/negative action, such as removing a user from your team.
 */

const error = {
  25: "#FFFBFA",
  50: "#FEF3F2",
  100: "#FEE4E2",
  200: "#FECDCA",
  300: "#FDA29B",
  400: "#F97066",
  500: "#F04438",
  600: "#D92D20",
  700: "#B42318",
  800: "#912018",
  900: "#7A271A",
  950: "#55160C",
};

export default error;
